import type { MessageDescriptor } from 'react-intl';
import type { DisplayMode } from '../stage/displayModes';
import { messages } from './messages';

/** In menu order, which is also the order of the 1–4 keys. */
export const DISPLAY_MODES: readonly { mode: DisplayMode; label: MessageDescriptor }[] = [
  { mode: 'solid-edges', label: messages.shadingEdged },
  { mode: 'shaded', label: messages.shadingShaded },
  { mode: 'ghosted', label: messages.shadingGhosted },
  { mode: 'wireframe', label: messages.shadingWireframe },
];

export const displayModeLabel = (mode: DisplayMode): MessageDescriptor =>
  (DISPLAY_MODES.find((entry) => entry.mode === mode) ?? DISPLAY_MODES[0]).label;
